import { Component, computed, inject, OnDestroy, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import {
  CryptotokenlistActions,
  selectCryptotokenlistGridData,
  selectCryptotokenlistDrilldownKey,
} from './cryptotokenlist.feature';
import { CryptoTokenDetailsComponent } from '../components/crypto-token-details/crypto-token-details.component';
import { MainTableComponent } from '../components/main-table/main-table.component';
import { CryptotokenDataService } from 'src/app/shared/store/features/cryptotoken-data/cryptotoken-data.service';

@Component({
  selector: 'app-cryptotokenlist',
  imports: [MainTableComponent, CryptoTokenDetailsComponent],
  templateUrl: './cryptotokenlist.component.html',
  styleUrl: './cryptotokenlist.component.scss',
})
export class CryptotokenlistComponent implements OnDestroy, OnInit {
  private store = inject(Store);
  private cryptotokenDataService = inject(CryptotokenDataService);
  private gridData$ = this.store.select(selectCryptotokenlistGridData);
  gridData = toSignal(this.gridData$);
  private drilldownTokenName = toSignal(
    this.store.select(selectCryptotokenlistDrilldownKey),
  );
  drilldown = computed(() => {
    const drilldownCaName = this.drilldownTokenName();
    return drilldownCaName
      ? this.gridData()?.rowData.find(
          ({ tokenName }) => tokenName === this.drilldownTokenName(),
        )
      : undefined;
  });

  onBack() {
    this.store.dispatch(CryptotokenlistActions.backFromDrilldown());
  }

  ngOnInit() {
    this.cryptotokenDataService.ensure();
    this.store.dispatch(CryptotokenlistActions.refresh());
  }

  ngOnDestroy() {
    this.cryptotokenDataService.clear();
  }
}
